import { IBookCategory } from 'src/types/DTO/bookCategory/IBookCategory';

export const toBookCategories = (data: any): IBookCategory[] =>
  data?.map((item: any) => ({
    id: item?.id,
    code: item?.categoryCode,
    name: item?.categoryName,
    description: item?.categoryDes,
  }));

export const toBookCategory = (item: any): IBookCategory => ({
  id: item?.id,
  code: item?.categoryCode,
  name: item?.categoryName,
  description: item?.categoryDes,
});
